var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAngleDoubleLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19_260)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.12097 11.2931L13.013 1.40006L11.6 -0.0129395L1.70697 9.87906C1.14456 10.4416 0.828613 11.2046 0.828613 12.0001C0.828613 12.7956 1.14456 13.5585 1.70697 14.1211L11.592 24.0061L13.006 22.5921L3.12197 12.7071C2.93437 12.5197 2.82887 12.2654 2.82869 12.0003C2.8285 11.7351 2.93363 11.4807 3.12097 11.2931Z",
    fill: "#F6DACF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 1.41712L21.583 0.00012207L10.293 11.2901C10.1056 11.4776 10.0002 11.7319 10.0002 11.9971C10.0002 12.2623 10.1056 12.5166 10.293 12.7041L21.584 24.0001L23 22.5841L12.414 12.0001L23 1.41712Z",
    fill: "#F6DACF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19_260"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleDoubleLeft);
export default __webpack_public_path__ + "static/media/angle-double-left.6ee62c2ccb692ae89c797f6cf5bd91a3.svg";
export { ForwardRef as ReactComponent };